import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';
import { CATEGORIES } from '../lib/categories';
import { fetchProducts } from '../lib/api';

const Categories = () => {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProducts()
      .then((list) => {
        const c = {};
        list.forEach((p) => {
          c[p.category] = (c[p.category] || 0) + 1;
        });
        setCounts(c);
      })
      .catch(() => setCounts(null));
  }, []);

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 max-w-7xl mx-auto" data-testid="categories-page">
      <div className="mb-12">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-foreground tracking-tight"
          data-testid="categories-page-title"
        >
          Browse Categories
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-muted-foreground mt-3 text-sm sm:text-base"
        >
          Find your vibe — {CATEGORIES.length} curated collections of premium posters
        </motion.p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
        {CATEGORIES.map((category, index) => (
          <motion.div
            key={category.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.04 }}
            data-testid={`category-tile-${category.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <Link to={`/shop?category=${encodeURIComponent(category.name)}`} className="block">
              <div className="group relative aspect-[4/5] overflow-hidden bg-secondary border border-border/40 rounded-sm">
                <img
                  src={category.image}
                  alt={category.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent group-hover:from-black/90 transition-all duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-4 flex items-end justify-between">
                  <div>
                    <h3 className="font-heading font-bold text-lg sm:text-xl text-white tracking-tight">
                      {category.name}
                    </h3>
                    {counts && (
                      <p className="text-xs text-white/70 mt-0.5" data-testid="category-tile-count">
                        {counts[category.name]
                          ? `${counts[category.name]} poster${counts[category.name] === 1 ? '' : 's'}`
                          : 'Coming soon'}
                      </p>
                    )}
                  </div>
                  <ArrowRight
                    size={20}
                    weight="bold"
                    className="text-white opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-1"
                  />
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
